"use strict";
/**
 * Created by rouven on 02.03.17.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var FullRow = function (_a) {
    var colSpan = _a.colSpan, children = _a.children;
    return (react_1["default"].createElement("tr", { key: "1" },
        react_1["default"].createElement("td", { colSpan: colSpan, className: "text-center" }, children)));
};
exports["default"] = FullRow;
